var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.image)?_c('v-row',{attrs:{"justify":"center","align":"center"}},[_c('v-col',{attrs:{"cols":"12","sm":"6","md":"3"}},[_c('img',{attrs:{"src":_vm.image,"alt":_vm.name,"width":"100%"}})])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }